import CUIContainer from 'connect-dot-com-ui-components/Components/CUIContainer/CUIContainer';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import SiteFooter from '../SiteFooter';
import SiteHeader from '../SiteHeader';
import { backgroundLinearGradientImageProps, baseLayoutContainerProps } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommunitiesLayout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(CUIFlex, Object.assign({
    direction: "column",
    flex: "1",
    minHeight: "100vh",
    "data-test-id": "communities-layout"
  }, backgroundLinearGradientImageProps, {
    children: [/*#__PURE__*/_jsx(SiteHeader, {}), /*#__PURE__*/_jsx(CUIContainer, Object.assign({}, baseLayoutContainerProps, {
      display: "flex",
      "data-test-id": "communities-layout-container",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignContent: "center",
      alignItems: "center",
      maxW: "768px",
      children: children
    })), /*#__PURE__*/_jsx(SiteFooter, {})]
  }));
};
export default CommunitiesLayout;